import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonDettaglioProdotto = () => {

  return (
    <SkeletonTheme baseColor="#121824" highlightColor="#1A2234">
      <main className="min-h-safe-screen bg-[#090D16] text-secondary pb-32 pt-[64px] relative">
        {/* Header */}
        <header className="fixed top-0 left-0 right-0 z-50 bg-[#0D121F]/90 backdrop-blur-md px-4 py-3 border-b border-accent/40 shadow-sm">
          <div className="flex items-center justify-between max-w-md mx-auto">
            <div className="p-2 border border-transparent rounded-xl">
              <Skeleton width={20} height={20} style={{ borderRadius: '6px' }} />
            </div>
            <div className="flex items-center">
              <Skeleton width={120} height={26} style={{ borderRadius: '9999px' }} />
            </div>
            <div className="w-9" />
          </div>
        </header>

        {/* Immagine Circolare */}
        <div className="px-6 pt-6 flex justify-center">
          <div className="w-72 h-72 rounded-full border-4 border-[#121824] shadow-sm overflow-hidden">
            <Skeleton width="100%" height="100%" circle />
          </div>
        </div>

        {/* Titolo e Prezzo PRO Skeleton */}
        <div className="mt-6 text-center px-6 max-w-md mx-auto space-y-3 flex flex-col items-center">
          <Skeleton width={200} height={24} style={{ borderRadius: '6px' }} />
          <div className="flex flex-col items-center space-y-1 pt-1">
            <Skeleton width={100} height={32} style={{ borderRadius: '8px' }} />
            <Skeleton width={80} height={10} style={{ borderRadius: '4px' }} />
          </div>
        </div>

        {/* Contenuto accessorio (es. Calorie / Drink info) */}
        <div className="px-4 mt-6 max-w-md mx-auto text-center">
          <Skeleton width={140} height={36} style={{ borderRadius: '12px' }} />
        </div>

        {/* Corpo Schede Informative */}
        <section className="px-4 max-w-md mx-auto space-y-4 pt-4">
          {/* Card Descrizione / Ingredienti */}
          <div className="bg-[#121824] p-4 rounded-2xl border border-accent/20 space-y-3">
            <Skeleton width={110} height={16} style={{ borderRadius: '4px' }} />
            <div className="flex flex-wrap gap-2 pt-1">
              <Skeleton width={70} height={26} style={{ borderRadius: '12px' }} />
              <Skeleton width={90} height={26} style={{ borderRadius: '12px' }} />
              <Skeleton width={65} height={26} style={{ borderRadius: '12px' }} />
              <Skeleton width={80} height={26} style={{ borderRadius: '12px' }} />
            </div>
          </div>

          <div className="bg-[#121824] p-4 rounded-2xl border border-accent/20 space-y-2">
            <Skeleton width={130} height={16} style={{ borderRadius: '4px' }} />
            <Skeleton count={2} height={12} style={{ borderRadius: '4px' }} />
          </div>
        </section>

        {/* Navigazione Floating Inferiore */}
        <div className="fixed bottom-5 left-1/2 -translate-x-1/2 w-[92%] max-w-sm bg-[#0D121F]/90 backdrop-blur-md border border-accent/60 rounded-2xl p-2.5 flex justify-between items-center z-30 shadow-2xl">
          <Skeleton width={70} height={32} style={{ borderRadius: '12px' }} />
          <Skeleton width={50} height={24} style={{ borderRadius: '12px' }} />
          <Skeleton width={70} height={32} style={{ borderRadius: '12px' }} />
        </div>
      </main>
    </SkeletonTheme>
  );
};

export default SkeletonDettaglioProdotto;